
    import * as React from 'react';

    const Mail16 = ({ color = 'currentcolor', height = '16px', width = '16px', ...rest }) => {
      const svgStyle: React.CSSProperties = {...{"position":"absolute","top":"0","right":"0","bottom":"0","left":"0","width":"100%","height":"100%"}, fill: color};

      return (
        <div style={{ ...{"position":"relative"}, height, width }} { ...rest }>
          <svg viewBox="0 0 16 16" style={svgStyle}><path d="M2.37 3.75l5.586 4.764L13.54 3.75H2.37zm11.88.38L7.956 9.5 1.75 4.206v8.044h12.5V4.13zM1 3h14v10H1V3z" /></svg>
        </div>
      );
    };

    Mail16.displayName = 'Mail16';

    export default Mail16;
  